var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.98438 11.2539H12.0098C13.2812 11.2539 13.9434 10.5977 13.9434 9.34375V2.21289C13.9434 0.958984 13.2812 0.302734 12.0098 0.302734H1.98438C0.71875 0.302734 0.0566406 0.953125 0.0566406 2.21289V9.34375C0.0566406 10.5977 0.71875 11.2539 1.98438 11.2539ZM1.22266 2.31836C1.22266 1.75 1.52148 1.46875 2.06055 1.46875H11.9336C12.4727 1.46875 12.7715 1.75 12.7715 2.31836V8.47656L9.85938 5.74609C9.5957 5.51172 9.29688 5.39453 8.98047 5.39453C8.6582 5.39453 8.37109 5.5 8.10156 5.74023L5.45898 8.10742L4.375 7.12891C4.12891 6.90625 3.85938 6.79492 3.58398 6.79492C3.31445 6.79492 3.07422 6.90039 2.83398 7.12305L1.22266 8.55859V2.31836ZM4.61523 5.88672C5.38281 5.88672 6.01562 5.25391 6.01562 4.47461C6.01562 3.70703 5.38281 3.06836 4.61523 3.06836C3.83594 3.06836 3.20312 3.70703 3.20312 4.47461C3.20312 5.25391 3.83594 5.88672 4.61523 5.88672Z",
    fill: "#BFBBCF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImage);
export default __webpack_public_path__ + "static/media/icon-image.6d7e85d5e9e7c5a4f109eaa84242247a.svg";
export { ForwardRef as ReactComponent };